import { render, staticRenderFns } from "./Drawers.vue?vue&type=template&id=1bbfc4bc&scoped=true&"
import script from "./Drawers.vue?vue&type=script&lang=js&"
export * from "./Drawers.vue?vue&type=script&lang=js&"
import style0 from "./Drawers.vue?vue&type=style&index=0&id=1bbfc4bc&prod&scoped=true&lang=css&"
import style1 from "./Drawers.vue?vue&type=style&index=1&id=1bbfc4bc&prod&scoped=true&lang=css&"
import style2 from "./Drawers.vue?vue&type=style&index=2&id=1bbfc4bc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bbfc4bc",
  null
  
)

export default component.exports